import React from "react";
import App from "./App";
import Modal from "react-modal";
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import { createRoot } from "react-dom/cjs/react-dom.production.min";
Amplify.configure(awsExports);

Modal.setAppElement("#root");

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />)

